var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_393",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29259",
    "data-name": "Group 29259",
    transform: "translate(360 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -11099)",
    filter: "url(#Ellipse_393)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393-2",
    "data-name": "Ellipse 393",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_13_",
    "data-name": "svgexport-17 (13)",
    transform: "translate(-343.696 -11078.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50051",
    "data-name": "Path 50051",
    d: "M185.005,107.917a.6.6,0,0,1-.549-.358l-3.334-7.6a.828.828,0,0,1,.48-1.112l.122-.043-3.415-.938-.826.232a.6.6,0,1,1-.324-1.153l.986-.277a.6.6,0,0,1,.321,0l5.118,1.406a.694.694,0,0,1,.049,1.324l-1.254.447,3.175,7.235a.6.6,0,0,1-.548.84Zm-14.778,1.018a.6.6,0,0,1-.576-.436l-1.717-6.056a.6.6,0,1,1,1.153-.327l1.717,6.056a.6.6,0,0,1-.577.763Z",
    transform: "translate(-154.664 -96.644)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50052",
    "data-name": "Path 50052",
    d: "M344.285,237.491a6.887,6.887,0,1,0,6.887,6.887A6.887,6.887,0,0,0,344.285,237.491Zm0,12.017a5.13,5.13,0,1,1,5.13-5.13A5.136,5.136,0,0,1,344.285,249.508Z",
    transform: "translate(-310.78 -226.379)",
    fill: "#0072a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50053",
    "data-name": "Path 50053",
    d: "M407.446,237.491a6.908,6.908,0,0,0-1.478.161,6.877,6.877,0,0,1,3.573,2.046,5.127,5.127,0,0,1,0,9.362,6.877,6.877,0,0,1-3.573,2.046,6.887,6.887,0,1,0,1.478-13.614Z",
    transform: "translate(-373.94 -226.379)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50054",
    "data-name": "Path 50054",
    d: "M6.887,240.754a6.887,6.887,0,1,0,6.887,6.887A6.887,6.887,0,0,0,6.887,240.754Zm0,12.017a5.13,5.13,0,1,1,5.13-5.13,5.136,5.136,0,0,1-5.13,5.13Z",
    transform: "translate(0 -229.385)",
    fill: "#0072a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50055",
    "data-name": "Path 50055",
    d: "M68.338,240.754a6.9,6.9,0,0,0-1.624.194,6.877,6.877,0,0,1,3.252,1.829,5.128,5.128,0,0,1,0,9.728,6.876,6.876,0,0,1-3.252,1.829,6.887,6.887,0,1,0,1.624-13.58Z",
    transform: "translate(-61.451 -229.385)",
    fill: "#006289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50056",
    "data-name": "Path 50056",
    d: "M377.482,228.1a.839.839,0,0,1-.767-.5l-3.243-7.329a.839.839,0,1,1,1.534-.679l3.243,7.329a.839.839,0,0,1-.766,1.178Z",
    transform: "translate(-343.94 -209.434)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50057",
    "data-name": "Path 50057",
    d: "M384.107,226.924l-3.243-7.329a.838.838,0,0,0-1.1-.428l3.92,8.864A.839.839,0,0,0,384.107,226.924Z",
    transform: "translate(-349.8 -209.436)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50058",
    "data-name": "Path 50058",
    d: "M96.642,148.85l-.708-1.6a.919.919,0,0,0-1.238-.456L82,152.9a.919.919,0,0,0-.486,1.076l.259.921-8.562,5.729a.919.919,0,0,0,.564,1.68l9.918-.575.129.46a.918.918,0,0,0,1.577.355l11.093-12.72a.919.919,0,0,0,.148-.975Zm-19.6,11.425,5.26-3.519.888,3.163Zm8.1-.218-1.409-5.017-.23-.82,11.143-5.36.088.2Z",
    transform: "translate(-67.063 -142.753)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50059",
    "data-name": "Path 50059",
    d: "M96.642,148.85l-.708-1.6a.919.919,0,0,0-1.238-.456L82,152.9a.919.919,0,0,0-.486,1.076l.259.921-8.562,5.729a.919.919,0,0,0,.564,1.68l9.918-.575.129.46a.918.918,0,0,0,1.577.355l11.093-12.72a.919.919,0,0,0,.148-.975Zm-19.6,11.425,5.26-3.519.888,3.163Zm8.1-.218-1.409-5.017-.23-.82,11.143-5.36.088.2Z",
    transform: "translate(-67.063 -142.753)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50060",
    "data-name": "Path 50060",
    d: "M96.708,149.04a.919.919,0,0,0-.06-.188l-.354-.8-.354-.8a.917.917,0,0,0-1.187-.477c-.017.007-.034.013-.051.021l-2.14,1.029.81,1.649,1.272-.612.088.2-1,1.146.1.212a.919.919,0,0,1-.148.975l-9.151,10.493-.024,0a.919.919,0,0,1-.682-.648l-.129-.46-9.918.575a.918.918,0,0,1-.837-.439A.92.92,0,0,0,72.9,161l0,0a.918.918,0,0,0-.063.181l0,.009q-.009.041-.014.082l0,.015a.912.912,0,0,0,0,.185c0,.008,0,.015,0,.023q0,.035.011.069l.005.026a.909.909,0,0,0,.383.559.917.917,0,0,0,.512.157h.053l9.918-.575.065.23.065.23h0a.906.906,0,0,0,.037.1l.016.035c.01.022.021.043.033.063s.014.026.022.038a.927.927,0,0,0,.056.079l.026.03.026.028.02.021.029.028a.929.929,0,0,0,.073.061l.028.019c.023.016.046.031.071.044l.021.012c.018.01.038.018.057.026l.038.017.025.009a.908.908,0,0,0,.106.032.924.924,0,0,0,.894-.292L96.5,149.828A.918.918,0,0,0,96.708,149.04Z",
    transform: "translate(-67.069 -142.756)",
    fill: "#f33a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50061",
    "data-name": "Path 50061",
    d: "M149.026,149.223l4.052-1.572a.443.443,0,0,0,.268-.525l-.024-.091a.443.443,0,0,0-.5-.325l-4.961.839a.443.443,0,0,0-.356.329l-.21.843a.443.443,0,0,0,.437.55l1.144-.018A.444.444,0,0,0,149.026,149.223Z",
    transform: "translate(-135.66 -142.753)",
    fill: "#ff4c4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_437",
    "data-name": "Ellipse 437",
    cx: 2.208,
    cy: 2.208,
    rx: 2.208,
    ry: 2.208,
    transform: "translate(15.547 16.555)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_438",
    "data-name": "Ellipse 438",
    cx: 2.653,
    cy: 2.653,
    rx: 2.653,
    ry: 2.653,
    transform: "translate(15.102 16.11)",
    fill: "#ffb123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50062",
    "data-name": "Path 50062",
    d: "M205.023,314.44a2.653,2.653,0,0,0,0-3.752l-3.752,3.752A2.653,2.653,0,0,0,205.023,314.44Z",
    transform: "translate(-185.392 -293.801)",
    fill: "#ff901d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50063",
    "data-name": "Path 50063",
    d: "M221.1,330.432a.6.6,0,0,1-.367-.126l-3.043-2.363a.6.6,0,1,1,.735-.946l2.563,1.99.4-.534a.6.6,0,0,1,.956.722l-.769,1.018A.6.6,0,0,1,221.1,330.432Z",
    transform: "translate(-200.299 -308.708)",
    fill: "#006289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/Bicycle.56d1bb92deea9fd8d984fd6129ff6c44.svg";
export { ForwardRef as ReactComponent };